import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-gray-900 border border-purple-500/30 rounded-xl p-3 shadow-xl">
      <p className="text-white font-semibold mb-2">{label}</p>
      {payload?.map((entry, i) => (
        <p key={i} className="text-sm" style={{ color: entry?.color }}>
          {entry?.name}: <span className="font-bold">{entry?.value}%</span>
        </p>
      ))}
    </div>
  );
};

const EngagementByLevelChart = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
        <div className="h-5 bg-white/20 rounded animate-pulse w-48 mb-6" />
        <div className="h-64 bg-white/10 rounded-xl animate-pulse" />
      </div>
    );
  }

  const hasData = data?.some(d => d?.totalViews > 0);

  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
      <div className="mb-5">
        <h2 className="text-white font-bold text-lg">Engagement by Lesson Level</h2>
        <p className="text-purple-300 text-sm mt-1">Average watch percentage and completion rate per level</p>
      </div>
      {!hasData ? (
        <div className="flex flex-col items-center justify-center h-64 text-purple-300">
          <p className="text-lg font-medium">No watch data yet</p>
          <p className="text-sm mt-1">Data will appear as students watch videos</p>
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={data} margin={{ top: 5, right: 20, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" />
            <XAxis
              dataKey="label"
              tick={{ fill: '#c4b5fd', fontSize: 12 }}
              axisLine={{ stroke: 'rgba(255,255,255,0.2)' }}
              tickLine={false}
            />
            <YAxis
              tick={{ fill: '#c4b5fd', fontSize: 12 }}
              axisLine={false}
              tickLine={false}
              domain={[0, 100]}
              tickFormatter={v => `${v}%`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend
              wrapperStyle={{ color: '#c4b5fd', fontSize: 12, paddingTop: 12 }}
            />
            <Bar
              dataKey="avgWatchPercentage"
              name="Avg Watch %"
              fill="#8b5cf6"
              radius={[6, 6, 0, 0]}
              maxBarSize={48}
            />
            <Bar
              dataKey="completionRate"
              name="Completion Rate %"
              fill="#34d399"
              radius={[6, 6, 0, 0]}
              maxBarSize={48}
            />
          </BarChart>
        </ResponsiveContainer>
      )}
      {/* Level stats row */}
      {hasData && (
        <div className="grid grid-cols-3 sm:grid-cols-6 gap-3 mt-5">
          {data?.map(level => (
            <div key={level?.level} className="bg-white/5 rounded-xl p-3 text-center">
              <p className="text-purple-200 text-xs font-medium mb-1">{level?.label}</p>
              <p className="text-white font-bold text-sm">{level?.avgWatchPercentage}%</p>
              <p className="text-purple-400 text-xs">{level?.uniqueViewers} viewers</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EngagementByLevelChart;
